import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    defaultContainer: {
        width: "100%",
        height: "100%",
        padding: theme.spacing(1),
    },
    listContainer: {
        "& .card": {
            margin: theme.spacing(1),
        }
    },
    title: {
        marginBottom: theme.spacing(2),
    },
    list: {
        position: 'initial',
    },
}));
